import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { querySiteFactorById } from '@/api/api';
import { getAction } from '@/api/manage';
import none from '@/assets/others/index/none.png';
import direct from '@assets/others/index/site_picture.png';
import fileList from '@/components/border/fileList';
import networkCard from '@/components/border/networkCard';
export default {
  components: {
    fileList: fileList,
    networkCard: networkCard
  },
  props: {
    siteDetail: {
      default: {},
      type: Object
    },
    selectId: {
      default: '0',
      type: String
    }
  },
  watch: {
    selectId: function selectId(val) {
      this.selectIndex = 1; // 获取因子列表

      this.getFactor(val);
      this.getNetworkCard(val);
    },
    dataSource: function dataSource() {
      if (this.dataSource.length > 0) this.scroll = {
        y: 430
      };else this.scroll = {};
    }
  },
  data: function data() {
    return {
      tableList: [],
      networkList: [],
      url: {
        imgServer: window._CONFIG['domianURL'] + '/sys/common/file/view'
      },
      columns: [{
        title: '监测因子',
        dataIndex: 'factorName',
        key: 'factorName',
        align: 'center',
        width: 150
      }, {
        title: '编号',
        dataIndex: 'code',
        key: 'code',
        align: 'center',
        width: 150
      }, {
        title: '限制类型',
        dataIndex: 'restrictionName',
        key: 'restrictionName',
        align: 'center',
        width: 150
      }, {
        title: '最小值',
        dataIndex: 'lower',
        key: 'lower',
        align: 'center',
        width: 150
      }, {
        title: '最大值',
        dataIndex: 'upper',
        key: 'upper',
        align: 'center',
        width: 150
      }, {
        title: '单位',
        dataIndex: 'unitName',
        key: 'unitName',
        align: 'center',
        width: 150
      }],
      networkColumns: [{
        title: 'iccid',
        dataIndex: 'iccid',
        key: 'iccid',
        align: 'center',
        width: 150
      }, {
        title: 'misidn',
        dataIndex: 'msisdn',
        key: 'msisdn',
        align: 'center',
        width: 150
      }, {
        title: '密钥名称',
        dataIndex: 'name',
        key: 'name',
        align: 'center',
        width: 150
      }, {
        title: '卡有效期',
        dataIndex: 'expiredAt',
        key: 'expiredAt',
        align: 'center',
        width: 150
      }, {
        title: '卡状态',
        dataIndex: 'status',
        key: 'status',
        align: 'center',
        width: 150
      }, {
        title: '已用流量(MB)',
        dataIndex: 'used',
        key: 'used',
        align: 'center',
        width: 150
      }, {
        title: '剩余流量(MB)',
        dataIndex: 'surplus',
        key: 'surplus',
        align: 'center',
        width: 150
      }, {
        title: '运营商',
        dataIndex: 'carrier',
        key: 'carrier',
        align: 'center',
        width: 150
      }],
      scroll: {},
      dataSource: [// {
        //     key: '1',
        //     code: 'w01001',
        // 	title:'PH',
        // 	unitName:'mg/L',
        // 	upper:100,
        // 	lower:1
        //   },
        //   {
        //       key: '2',
        //       code: 'w01002',
        //   	title:'化学需氧量',
        //   	unitName:'mg/L',
        //   	upper:200,
        //   	lower:2
        //     },
      ],
      tabList: [{
        name: '监测因子',
        id: 1
      }, {
        name: '八方位图',
        id: 2
      }, {
        name: '内景图',
        id: 3
      }, {
        name: '物联网卡',
        id: 4
      }],
      selectIndex: 1,
      imgList: [],
      //八位图列表
      innerImglist: [] //内景图列表

    };
  },
  methods: {
    // 获取内景图
    getInnerPic: function getInnerPic(id) {
      var _this = this;

      getAction("/sys/common/file/queryFile/site_info_file/".concat(id)).then(function (res) {
        if (res.success && res.result.length > 0) {
          res.result.forEach(function (item, index) {
            item.src = _this.getImageView(item.id);
          });
          _this.innerImglist = res.result;
        } else {
          _this.innerImglist = [];
        }
      });
    },
    getImageView: function getImageView(photo) {
      return this.url.imgServer + '/' + photo;
    },
    // 获取八位图
    getPic: function getPic(id) {
      var _this2 = this;

      this.imgList = [];
      getAction("/site/picture/find/".concat(id)).then(function (res) {
        if (res.success) {
          _this2.imgList = [{
            src: res.result.northwest ? _this2.getImageView(res.result.northwest) : none
          }, {
            src: res.result.north ? _this2.getImageView(res.result.north) : none
          }, {
            src: res.result.northeast ? _this2.getImageView(res.result.northeast) : none
          }, {
            src: res.result.west ? _this2.getImageView(res.result.west) : none
          }, {
            src: direct
          }, {
            src: res.result.east ? _this2.getImageView(res.result.east) : none
          }, {
            src: res.result.southwest ? _this2.getImageView(res.result.southwest) : none
          }, {
            src: res.result.south ? _this2.getImageView(res.result.south) : none
          }, {
            src: res.result.southeast ? _this2.getImageView(res.result.southeast) : none
          }];

          _this2.$previewRefresh();
        } else {
          for (var i = 0; i < 8; i++) {
            var obj = {};
            obj.src = none;

            _this2.imgList.push(obj);
          }

          _this2.imgList.splice(4, 0, {
            src: direct
          });

          _this2.$previewRefresh();
        }
      });
    },
    // 获取因子列表
    getFactor: function getFactor(siteId) {
      var _this3 = this;

      getAction("/site/info/factor/find/".concat(siteId)).then(function (res) {
        if (res.success) {
          _this3.tableList = res.result; // this.dataSource = res.result
        } else {
          _this3.tableList = [];
        }
      }); // querySiteFactorById({
      // 	siteId,
      // 	pageNo: 1,
      // 	pageSize: 10000
      // }).then(res => {
      // })
    },
    //获取物联网卡列表
    getNetworkCard: function getNetworkCard(siteId) {
      var _this4 = this;

      var param = {
        scope: 1,
        scopeId: siteId,
        siteId: siteId
      };
      getAction("/site/iot/network/card", param).then(function (res) {
        if (res.success) {
          if (res.result) {
            _this4.networkList = res.result.records;
          } else {
            _this4.networkList = [];
          }
        } else {
          _this4.networkList = [];
        }
      });
    },
    onTotab: function onTotab(id) {
      if (this.selectIndex == id) return;
      this.selectIndex = id;

      switch (id) {
        case 1:
          this.getFactor(this.selectId);
          break;

        case 2:
          // 获取八位图
          this.getPic(this.selectId);
          break;

        case 3:
          // 获取内景图
          this.getInnerPic(this.selectId);
          break;
      }
    }
  }
};